// SPDX-License-Identifier: AGPL-3.0-or-later
//
// parley: drop a remote voice connection from the MoQ room the moment the
// gateway says it left (docs/voice.md). The relay only notices when the
// leaver's session times out, seconds later; until then the participant
// stayed listed and audible, and was then cut off mid-waveform.

import MediaEngine from '@app/features/voice/engine/MediaEngineFacade';

interface DroppingRoom {
	dropConnection?: (identity: string) => void;
	readmitConnection?: (identity: string) => void;
}

/** `user_<userId>_<connectionId>` is the voice identity (VoiceParticipantIdentity). */
export function dropLeftVoiceConnection(userId: string, connectionId: string): void {
	if (connectionId === MediaEngine.connectionId) return; // ourselves: the room is being left anyway
	(MediaEngine.room as unknown as DroppingRoom | null)?.dropConnection?.(`user_${userId}_${connectionId}`);
}

/** The connection is (back) in our channel, e.g. moved here by a moderator. */
export function readmitVoiceConnection(userId: string, connectionId: string): void {
	(MediaEngine.room as unknown as DroppingRoom | null)?.readmitConnection?.(`user_${userId}_${connectionId}`);
}
